import React from 'react';
import {Outlet} from "react-router-dom";
import Header from './layouts/Header';
import Footer from './layouts/Footer';

const Layout = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-fill">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
export default Layout;

